module.exports = __webpack_public_path__ + "img/bid_img3.27ef69a6.jpg";